import gql from 'graphql-tag';
export default gql`
  mutation saveCalculatorLeadDialler($calcLeadDialler: SaveCalcLeadDiallerInput) {
    saveCalculatorLeadDialler(calcLeadDialler: $calcLeadDialler) {
      leadId
      success
    }
  }
`;
